// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import SidebarAd from "../Blog/SidebarAd";
import ReleaventTopics from "../Blog/ReleaventTopics";
import Subscribe from "../NewsLetters/Subscribe";
import FollowMeOn from "./FollowMeOn";

function renderSection(section, adVariant) {
  switch (section) {
    case "ad":
      return <SidebarAd variant={adVariant} />;
    case "relatedTopics":
      return <ReleaventTopics />;
    case "subscribe":
      return <Subscribe />;
    case "followMe":
      return <FollowMeOn />;
    default:
      return null;
  }
}

export default function SidebarContentGroup({ className, sections = [], adVariant = "sidebar" }) {
  return (
    <div className={className}>
      {sections.map((section, index) => (
        <React.Fragment key={`${section}-${index}`}>
          {renderSection(section, adVariant)}
        </React.Fragment>
      ))}
    </div>
  );
}